module.exports = __webpack_public_path__ + "assets/img/cf51b88d7c7c04b155960168622e1afb.svg";